import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Bell, CheckCircle2 } from 'lucide-react';
import axios from 'axios';
import { Modal } from './Modal';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const inputCls = 'w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-[#7dd3fc]/50 transition-colors';

export const NotifyModal = ({ open, onClose, productName }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    onClose();
    setTimeout(() => { setSent(false); setEmail(''); setError(''); }, 300);
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/notify-me`, { email, product_name: productName });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={sent ? 'Aviso Registrado!' : 'Me Notifique'}
      subtitle={sent ? null : `Informe seu e-mail e avisaremos quando ${productName} estiver disponível.`}
      testId="notify-modal"
    >
      {sent ? (
        <div className="text-center py-4" data-testid="notify-success">
          <CheckCircle2 size={56} className="text-[#7dd3fc] mx-auto mb-4" />
          <p className="text-white/70 mb-6">Perfeito! Você será notificado assim que <strong>{productName}</strong> estiver disponível.</p>
          <button
            onClick={handleClose}
            className="px-6 py-2.5 bg-gradient-to-r from-[#7dd3fc] to-[#bae6fd] text-[#0a1628] font-bold rounded-xl"
          >
            Fechar
          </button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && <div className="p-3 bg-red-500/10 border border-red-500/30 rounded-lg text-red-300 text-sm">{error}</div>}
          <input required type="email" placeholder="Seu melhor e-mail" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="notify-email-input" />
          <motion.button
            type="submit"
            disabled={loading}
            whileHover={{ scale: loading ? 1 : 1.02 }}
            whileTap={{ scale: loading ? 1 : 0.98 }}
            className="w-full py-3.5 bg-gradient-to-r from-[#7dd3fc] to-[#bae6fd] text-[#0a1628] font-bold rounded-xl shadow-lg flex items-center justify-center gap-2 disabled:opacity-60"
            data-testid="notify-submit-btn"
          >
            <Bell size={18} />
            <span>{loading ? 'Enviando...' : 'Me Avise'}</span>
          </motion.button>
        </form>
      )}
    </Modal>
  );
};
